import classNames from 'classnames';
import { BigNumbersBox } from '../../../../../../components/BigNumbersBox';
import { LoadingSpinerLocal } from '../../../../../../components/LoadingSpinner';
import { IndicatorCardModel } from '../BigNumbersArea.types';
import styles from '../styles.module.scss';
import { InfoTooltip } from './InfoTooltip';

interface IndicatorCardProps {
  card: IndicatorCardModel;
  loading: boolean;
}

// Cards de rótulo longo e valor único: o rótulo quebra em 2 linhas e o card fica estreito, como no protótipo.
const WRAPPED_LABEL_CARDS: ReadonlyArray<IndicatorCardModel['id']> = ['salesVolume', 'profitDifference'];

export const IndicatorCard = ({ card, loading }: IndicatorCardProps) => {
  const wrappedLabel = WRAPPED_LABEL_CARDS.includes(card.id);

  return (
    <InfoTooltip text={card.tooltip} placement="right" preventOverflow>
      <div className={styles['indicator-card-trigger']} data-testid={`indicator-card-${card.id}`}>
        <BigNumbersBox.Root
          height="73px"
          marginRight="0"
          type={card.type}
          className={classNames(styles['indicator-card'], { [styles['compact-card']]: wrappedLabel })}
        >
          <LoadingSpinerLocal size="sm" position="absolute" loading={loading} />
          <div className={styles['flex-center']}>
            <BigNumbersBox.MainValue>{card.value}</BigNumbersBox.MainValue>
            {card.variation ? (
              <BigNumbersBox.Indicator decimal={1} percentPoint={card.variation.percentPoint} indicator={card.variation.value} compactPercent />
            ) : null}
          </div>
          <div className={classNames({ [styles['wrapped-label']]: wrappedLabel, [styles['volume-label']]: card.id === 'salesVolume' })}>
            <BigNumbersBox.RegularText>{card.label}</BigNumbersBox.RegularText>
          </div>
          {card.current ? (
            <div className={styles['flex-base']}>
              <BigNumbersBox.RegularText>atual</BigNumbersBox.RegularText>{' '}
              <BigNumbersBox.BoldText className={styles['bold-text-value']}>{card.current}</BigNumbersBox.BoldText>
            </div>
          ) : null}
        </BigNumbersBox.Root>
      </div>
    </InfoTooltip>
  );
};
